export default __webpack_public_path__ + "static/media/image3.522ef142.jpg";